import Icon from '../components/Icon.vue'

Icon.register({"map":{"width":576,"height":512,"paths":[{"d":"M576 56V392A24-24 0 0 0 562.7 413.5L434.7 477.5C418.9 485.3 400 474 400 456V120A24-24 0 0 0 413.3 98.5L541.3 34.5C557.1 26.7 576 38 576 56zM369.7 98.1L225.7 34.1C210 27.1 192 38.5 192 56V392A24-24 0 0 1 206.3 413.9L350.3 477.9C366 484.9 384 473.5 384 456V120A24-24 0 0 1 369.7 98.1zM141.3 34.5L13.3 98.5A24-24 0 0 1 0 120V456C0 474 18.9 485.3 34.7 477.5L162.7 413.5A24-24 0 0 1 176 392V56C176 38 157.1 26.7 141.3 34.5z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/map.js